<template>
  <div class="uni-promotion-new-page">
    <common-table
      :limitHeight="true"
      :table-columns="tableColumns"
      pageName="UniPromotionNew"
      :url="url"
      :operate="operate"
      :saveSelectObj="saveSelectObj"
      :savePromotionConfigObj="savePromotionConfigObj"
      :searchs="searchs"
      :operateLength="250"
      :form-fields="formFields"
      :permission="permission"
      :route_params="route_params"
      @selectProduct="selectProduct"
      @selectChange="selectChange"
      @openPromotionConfig="openPromotionConfig"
      @isPageSmall="isPageSmall"
    />

    <el-drawer
      :visible.sync="showSelectProductPopup"
      :size="pageSmall ? '100%' : '50%'"
      direction="rtl"
      :with-header="false"
    >
      <div class="drawer_title">选择商品</div>
      <div class="p20 pt30 product-drawer-body">
        <div class="font-bold pb20">
          在巨量千川全域推广任务中，若执行商品新增或商品修改操作，将触发任务全量更新，此过程可能导致素材丢失，请谨慎操作并提前做好素材备份。
        </div>
        <div class="flex-between pl20">
          <div class="fs13 c_999">
            支持搜索商品名称/ID，多选后统一保存到当前账户配置。
          </div>
          <div class="flex alcenter fs14">
            <el-checkbox
              v-model="isSelect30"
              :style="pageSmall ? 'display:flex;align-items:center;' : 'transform:scale(1.2);display:flex;align-items:center;'"
              @change="isCheckedChange"
            >
              点击选择前30条
            </el-checkbox>
          </div>
        </div>
        <div class="mt20 search-row">
          <el-input
            v-model.trim="productSearchText"
            class="search-input"
            clearable
            placeholder="请输入商品名称/ID搜索"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <div class="selected-counter">已选 {{ selectedList.length }}/30</div>
        </div>
        <div class="mt20">
          <el-table
            ref="prodcutTable"
            v-loading="loading"
            :row-class-name="'row-pointer'"
            :data="filteredProductTableData"
            :height="pageSmall ? '65vh' : '73vh'"
            border
            style="width: 100%"
            header-cell-class-name="header_className"
            @row-click="rowClick"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="productInfo" label="商品信息" width="400" align="left">
              <template slot-scope="scope">
                <div class="add_product_box flex alcenter">
                  <img :src="scope.row.img || scope.row.productImage" alt="">
                  <div class="pl10">
                    <div class="overflow1">{{ scope.row.productName }}</div>
                    <div class="overflow1 c_999">ID:{{ scope.row.productId }}</div>
                    <div class="overflow1 c_999">价格 {{ scope.row.price || '--' }}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="标签" width="150">
              <template slot-scope="scope">
                <el-tag class="mt5" v-for="(item, index) in scope.row.tagArr" :key="index">
                  {{ item }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="categoryName" label="类目" width="150"></el-table-column>
            <el-table-column prop="sellNum" label="销量"></el-table-column>
            <el-table-column prop="address" label="库存"></el-table-column>
          </el-table>
          <div
            class="flex-center pt20"
            :class="{ 'c_346bf6': hasMore }"
            @click="loadMoreProducts"
          >
            {{ hasMore ? '点击加载更多' : '暂无更多' }}
          </div>
          <div class="footer_box flex-between">
            <div class="flex alcenter pr5">
              已选:{{ selectedList.length }}
              <div class="flex alcenter selectedListBox">
                <div class="relative ml10" v-for="(item, index) in selectedList" :key="item.productId || index">
                  <img :src="item && item.img || item.productImage" alt="">
                  <i class="el-icon-error" @click="toggleRowSelection(item, index)"></i>
                </div>
              </div>
            </div>
            <div class="flex alcenter">
              <el-button class="flex-center responsiveButton" round @click="saveProduct(0)">取消</el-button>
              <el-button class="flex-center responsiveButton" type="primary" round @click="saveProduct(1)">
                保存商品
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

    <el-drawer
      :visible.sync="showPromotionConfigDrawer"
      :size="pageSmall ? '100%' : '78%'"
      direction="rtl"
      :with-header="false"
      custom-class="promotion-config-drawer"
    >
      <div class="drawer_title">配置投放</div>
      <div class="promotion-config-wrapper">
        <div class="promotion-config-main">
          <div class="step-card">
            <div class="step-header">
              <div class="step-index">1</div>
              <div>
                <div class="step-title">选择商品</div>
                <div class="step-subtitle">保留批量账户能力，每个账户单独配置商品与素材</div>
              </div>
            </div>
            <div class="account-summary">
              <div class="summary-item">
                <span class="summary-label">广告账户</span>
                <span class="summary-value">{{ currentRowAccountName }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">抖音号</span>
                <span class="summary-value">{{ currentRowDyName }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">已选商品</span>
                <span class="summary-value">{{ promotionConfigProducts.length }}/30</span>
              </div>
            </div>
            <div class="goods-toolbar">
              <el-button type="primary" icon="el-icon-plus" @click="openProductDrawerFromConfig">
                添加商品
              </el-button>
              <span class="goods-tip">支持在当前账户下多选商品，保存后回写到批量列表。</span>
            </div>
            <div class="goods-grid" v-if="promotionConfigProducts.length">
              <div
                v-for="product in promotionConfigProducts"
                :key="product.productId"
                class="goods-card"
                :class="{ active: currentConfigProductId === product.productId }"
                @click="switchConfigProduct(product.productId)"
              >
                <img :src="product.productImage || product.img" alt="">
                <div class="goods-card-content">
                  <div class="goods-name">{{ product.productName }}</div>
                  <div class="goods-id">ID:{{ product.productId }}</div>
                  <div class="goods-status" :class="getProductStatusClass(product.productId)">
                    {{ getProductStatusText(product.productId) }}
                  </div>
                </div>
              </div>
            </div>
            <el-empty v-else description="请先为当前账户选择商品"></el-empty>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">2</div>
              <div>
                <div class="step-title">投放设置</div>
                <div class="step-subtitle">首期仅支持控成本投放，字段与当前后端能力保持一致</div>
              </div>
            </div>
            <div class="delivery-mode-grid">
              <div class="delivery-mode-card active">
                <div class="delivery-mode-title">控成本投放</div>
                <div class="delivery-mode-desc">使用净成交 ROI 目标控制成本，适合当前系统批量创建主链路。</div>
              </div>
              <div class="delivery-mode-card disabled">
                <div class="delivery-mode-title">放量投放</div>
                <div class="delivery-mode-desc">敬请期待，当前版本暂不开放。</div>
              </div>
            </div>
            <div class="budget-grid">
              <div class="budget-item">
                <div class="budget-label">日预算</div>
                <el-input-number
                  v-model="promotionConfigForm.dayBudget"
                  :min="300"
                  :max="999999999.99"
                  :precision="2"
                  :step="100"
                  controls-position="right"
                  class="budget-input"
                ></el-input-number>
                <div class="field-tip">范围 300 - 999999999.99 元</div>
              </div>
              <div class="budget-item">
                <div class="budget-label">净成交 ROI 目标</div>
                <el-input-number
                  v-model="promotionConfigForm.roiTarget"
                  :min="0.01"
                  :max="10000"
                  :precision="2"
                  :step="0.1"
                  controls-position="right"
                  class="budget-input"
                ></el-input-number>
                <div class="field-tip">范围 0.01 - 10000</div>
              </div>
            </div>
            <div class="schedule-block">
              <div class="budget-label">投放时间</div>
              <el-radio-group v-model="promotionConfigForm.scheduleType">
                <el-radio-button label="LONG_TERM">从今天起长期投放</el-radio-button>
                <el-radio-button label="CUSTOM">设置开始和结束日期</el-radio-button>
              </el-radio-group>
              <div class="mt15" v-if="promotionConfigForm.scheduleType === 'CUSTOM'">
                <el-date-picker
                  v-model="promotionConfigForm.timeRange"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  class="time-range-picker"
                ></el-date-picker>
              </div>
            </div>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">3</div>
              <div>
                <div class="step-title">素材设置</div>
                <div class="step-subtitle">支持自动素材和自选素材，自选模式按商品逐个配置视频与标题</div>
              </div>
            </div>
            <div class="material-mode-grid">
              <div
                class="material-mode-card"
                :class="{ active: promotionConfigForm.materialMode === 'AUTO' }"
                @click="promotionConfigForm.materialMode = 'AUTO'"
              >
                <div class="material-mode-title">自动素材</div>
                <div class="material-mode-desc">继续沿用后端自动拉取素材逻辑，兼容现有批量创建方式。</div>
              </div>
              <div
                class="material-mode-card"
                :class="{ active: promotionConfigForm.materialMode === 'MANUAL' }"
                @click="promotionConfigForm.materialMode = 'MANUAL'"
              >
                <div class="material-mode-title">自选素材</div>
                <div class="material-mode-desc">前端选择每个商品的投放视频与标题，后台按照选择结果上架。</div>
              </div>
            </div>

            <div v-if="promotionConfigForm.materialMode === 'AUTO'" class="auto-material-box">
              <i class="el-icon-magic-stick"></i>
              <span>当前账户将继续使用系统自动素材，批量创建时不会额外要求素材选择。</span>
            </div>

            <div v-else class="manual-material-layout">
              <div class="manual-material-main">
                <div class="manual-product-tabs">
                  <div
                    v-for="product in promotionConfigProducts"
                    :key="product.productId"
                    class="manual-product-tab"
                    :class="{ active: currentConfigProductId === product.productId }"
                    @click="switchConfigProduct(product.productId)"
                  >
                    <img :src="product.productImage || product.img" alt="">
                    <div class="manual-product-meta">
                      <div class="manual-product-name">{{ product.productName }}</div>
                      <div class="manual-product-status" :class="getProductStatusClass(product.productId)">
                        {{ getProductStatusText(product.productId) }}
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="currentConfigProduct" class="material-editor">
                  <div class="material-editor-header">
                    <div>
                      <div class="editor-title">当前商品素材</div>
                      <div class="editor-subtitle">
                        商品ID：{{ currentConfigProduct.productId }}，每个商品首期需选择 1 条视频素材
                      </div>
                    </div>
                    <div class="editor-actions">
                      <el-button type="primary" icon="el-icon-video-play" @click="openMaterialDialog(currentConfigProduct)">
                        选择视频素材
                      </el-button>
                      <el-button
                        v-if="hasSelectedCreative(currentConfigProduct.productId)"
                        type="text"
                        class="danger-text"
                        @click="clearProductCreative(currentConfigProduct.productId)"
                      >
                        清空当前素材
                      </el-button>
                    </div>
                  </div>

                  <div class="selected-material-panel" v-if="getSelectedCreative(currentConfigProduct.productId)">
                    <div class="material-preview-card">
                      <img :src="getSelectedCreative(currentConfigProduct.productId).selectedVideoCoverUrl || currentConfigProduct.productImage || currentConfigProduct.img" alt="">
                      <div class="preview-duration" v-if="getMaterialDuration(currentConfigProduct.productId)">
                        {{ getMaterialDuration(currentConfigProduct.productId) }}
                      </div>
                    </div>
                    <div class="material-form">
                      <div class="budget-label">素材标题</div>
                      <el-input
                        v-model.trim="promotionConfigSelectedCreativeMap[currentConfigProduct.productId].selectedTitle"
                        type="textarea"
                        :rows="3"
                        maxlength="100"
                        show-word-limit
                        placeholder="请输入素材标题"
                      ></el-input>
                      <div class="material-field-row">
                        <div class="material-field">
                          <div class="mini-label">视频ID</div>
                          <div class="mini-value">{{ getSelectedCreative(currentConfigProduct.productId).selectedVideoId }}</div>
                        </div>
                        <div class="material-field">
                          <div class="mini-label">素材ID</div>
                          <div class="mini-value">{{ getSelectedCreative(currentConfigProduct.productId).selectedMaterialId || '--' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <el-empty v-else description="当前商品还未选择素材"></el-empty>
                </div>
                <el-empty v-else description="请先选择商品"></el-empty>
              </div>

              <div class="manual-material-preview">
                <div class="preview-phone">
                  <div class="preview-phone-header">
                    <span>素材预览</span>
                    <span>{{ getProductStatusText(currentConfigProductId) }}</span>
                  </div>
                  <div class="preview-phone-body" v-if="currentConfigProduct">
                    <img
                      class="preview-cover"
                      :src="getPreviewCover()"
                      alt=""
                    >
                    <div class="preview-product">
                      <img :src="currentConfigProduct.productImage || currentConfigProduct.img" alt="">
                      <div>
                        <div class="preview-product-name">{{ currentConfigProduct.productName }}</div>
                        <div class="preview-product-id">商品ID：{{ currentConfigProduct.productId }}</div>
                      </div>
                    </div>
                    <div class="preview-title">
                      {{ getPreviewTitle() }}
                    </div>
                  </div>
                  <el-empty v-else description="暂无商品预览"></el-empty>
                </div>
              </div>
            </div>
          </div>

          <div class="step-card">
            <div class="step-header">
              <div class="step-index">4</div>
              <div>
                <div class="step-title">计划确认</div>
                <div class="step-subtitle">保存后会回写到批量账户列表，再统一提交创建</div>
              </div>
            </div>
            <div class="confirm-grid">
              <div class="confirm-item">
                <div class="confirm-label">投放方式</div>
                <div class="confirm-value">控成本投放</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">素材模式</div>
                <div class="confirm-value">{{ promotionConfigForm.materialMode === 'MANUAL' ? '自选素材' : '自动素材' }}</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">预算/ROI</div>
                <div class="confirm-value">{{ promotionConfigForm.dayBudget || '--' }} 元 / {{ promotionConfigForm.roiTarget || '--' }}</div>
              </div>
              <div class="confirm-item">
                <div class="confirm-label">已配素材</div>
                <div class="confirm-value">{{ getConfiguredProductCount() }}/{{ promotionConfigProducts.length }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="promotion-config-footer">
          <el-button round @click="showPromotionConfigDrawer = false">取消</el-button>
          <el-button type="primary" round @click="savePromotionConfig">保存当前账户配置</el-button>
        </div>
      </div>
    </el-drawer>

    <el-dialog
      :visible.sync="showMaterialDialog"
      width="72%"
      append-to-body
      class="material-dialog"
      title="选择视频素材"
    >
      <div class="material-dialog-toolbar">
        <div class="toolbar-left">
          <span class="dialog-product-name">{{ materialDialogProductName }}</span>
          <span class="dialog-product-id" v-if="materialDialogProductId">商品ID：{{ materialDialogProductId }}</span>
        </div>
        <div class="toolbar-right">
          <el-button type="text" @click="reloadMaterialOptions">重新加载</el-button>
        </div>
      </div>
      <div v-loading="materialDialogLoading" class="material-dialog-body">
        <el-empty
          v-if="!materialDialogLoading && !materialDialogList.length"
          description="当前商品暂无可用素材，请稍后重试"
        ></el-empty>
        <div v-else class="material-dialog-grid">
          <div
            v-for="item in materialDialogList"
            :key="item.videoId"
            class="material-dialog-card"
            :class="{ active: materialDialogSelectedVideoId === item.videoId }"
            @click="materialDialogSelectedVideoId = item.videoId"
          >
            <div class="dialog-cover-wrapper">
              <img :src="item.videoCoverUrl" alt="">
              <div class="dialog-duration" v-if="item.duration">{{ item.duration }}</div>
            </div>
            <div class="dialog-card-title">{{ item.title || '未返回标题' }}</div>
            <div class="dialog-card-meta">视频ID：{{ item.videoId }}</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showMaterialDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmMaterialSelection">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'UniPromotionNew',
  components: { CommonTable },
  data() {
    return {
      pageSmall: false,
      route_params: {},
      loading: false,
      hasMore: false,
      productCursor: 0,
      currentTableIndex: null,
      productSearchText: '',
      productTableData: [],
      selectedList: [],
      saveSelectObj: {},
      savePromotionConfigObj: {},
      isSelect30: false,
      showSelectProductPopup: false,
      showPromotionConfigDrawer: false,
      showMaterialDialog: false,
      materialDialogLoading: false,
      materialDialogList: [],
      materialDialogSelectedVideoId: null,
      materialDialogProductId: null,
      materialDialogProductName: '',
      currentRowData: null,
      currentPromotionIndex: null,
      currentConfigProductId: null,
      promotionConfigProducts: [],
      promotionConfigSelectedCreativeMap: {},
      materialOptionMap: {},
      promotionConfigForm: {
        deliveryMode: 'COST',
        materialMode: 'AUTO',
        dayBudget: null,
        roiTarget: null,
        scheduleType: 'LONG_TERM',
        timeRange: []
      },
      searchs: [],
      permission: {
        update: 'uniPromotionTask:update',
        delete: 'uniPromotionTask:delete',
        deleteBatch: 'uniPromotionTask:deleteBatch'
      },
      url: {
        get: '/uniPromotionTask/listByCondition',
        add: '/uniPromotionTask/add',
        update: '/uniPromotionTask/update',
        delete2: '/uniPromotionTask/delete',
        delete_batch: '/uniPromotionTask/deleteBatch',
        status: '/uniPromotionTask/status'
      },
      tableColumns: [{
        field: 'account',
        label: '广告账户',
        show: true,
        account: true,
        width: '330'
      }, {
        field: 'dyNumber',
        label: '抖音号',
        sort: false,
        dyNumber: true,
        show: true,
        width: '330'
      }, {
        field: 'name',
        label: '商品组',
        sort: false,
        show: true,
        productGroup: true,
        width: '390'
      }, {
        field: 'editProductAction',
        label: '编辑商品',
        sort: false,
        show: true,
        editProductAction: true,
        width: '110'
      }, {
        field: 'promotionAction',
        label: '商品配置投放',
        sort: false,
        show: true,
        promotionAction: true,
        width: '130'
      }, {
        field: 'name',
        label: '整体ROI目标/日预算',
        sort: false,
        show: true,
        target: true
      }],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [{
          field: 'id',
          label: 'ID',
          type: 'input',
          add: false,
          update: true
        }, {
          field: 'agentId',
          label: 'agentId',
          type: 'input',
          placeholder: '请输入agentId',
          rules: [{ required: true, message: 'agentId不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'name',
          label: 'name',
          type: 'input',
          placeholder: '请输入name',
          rules: [{ required: true, message: 'name不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'type',
          label: 'type',
          type: 'input',
          placeholder: '请输入type',
          rules: [{ required: true, message: 'type不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'target',
          label: 'target',
          type: 'input',
          placeholder: '请输入target',
          rules: [{ required: true, message: 'target不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'uniPromotionNum',
          label: 'uniPromotionNum',
          type: 'input',
          placeholder: '请输入uniPromotionNum',
          rules: [{ required: true, message: 'uniPromotionNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'successNum',
          label: 'successNum',
          type: 'input',
          placeholder: '请输入successNum',
          rules: [{ required: true, message: 'successNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'waitNum',
          label: 'waitNum',
          type: 'input',
          placeholder: '请输入waitNum',
          rules: [{ required: true, message: 'waitNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }, {
          field: 'failNum',
          label: 'failNum',
          type: 'input',
          placeholder: '请输入failNum',
          rules: [{ required: true, message: 'failNum不能为空', trigger: 'blur' }],
          add: true,
          update: true
        }]
      },
      operate: []
    }
  },
  computed: {
    filteredProductTableData() {
      const keyword = (this.productSearchText || '').trim().toLowerCase()
      if (!keyword) {
        return this.productTableData
      }
      return this.productTableData.filter((item) => {
        const productName = item.productName ? String(item.productName).toLowerCase() : ''
        const productId = item.productId ? String(item.productId).toLowerCase() : ''
        return productName.indexOf(keyword) !== -1 || productId.indexOf(keyword) !== -1
      })
    },
    currentConfigProduct() {
      if (!this.currentConfigProductId) {
        return null
      }
      return this.promotionConfigProducts.find((item) => String(item.productId) === String(this.currentConfigProductId)) || null
    },
    currentRowAccountName() {
      const row = this.currentRowData || {}
      return row.account && row.account.name ? row.account.name : '--'
    },
    currentRowDyName() {
      const row = this.currentRowData || {}
      if (row.selectedDYNumber && row.selectedDYNumber.name) {
        return row.selectedDYNumber.name
      }
      return '--'
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler() {
        if (this.$route.query.advertiserName || this.$route.query.id) {
          this.route_params = Object.assign({}, this.route_params, this.$route.query)
        }
      }
    }
  },
  methods: {
    isPageSmall(data) {
      this.pageSmall = data
    },
    cloneValue(value, defaultValue) {
      if (value === undefined || value === null) {
        return defaultValue
      }
      return JSON.parse(JSON.stringify(value))
    },
    normalizeProduct(item) {
      const product = this.cloneValue(item, {})
      product.productName = product.productName || product.productname || ''
      product.productname = product.productName
      product.productImage = product.productImage || product.img || ''
      product.img = product.img || product.productImage || ''
      return product
    },
    normalizeProductList(list) {
      if (!Array.isArray(list)) {
        return []
      }
      return list.map((item) => this.normalizeProduct(item))
    },
    mergeProductList(baseList, appendList) {
      const map = {}
      return this.normalizeProductList(baseList.concat(appendList)).filter((item) => {
        const key = item && item.productId ? String(item.productId) : ''
        if (!key) {
          return false
        }
        if (map[key]) {
          return false
        }
        map[key] = true
        return true
      })
    },
    normalizeSelectedCreativeMap(list) {
      const map = {}
      if (!Array.isArray(list)) {
        return map
      }
      list.forEach((item) => {
        if (item && item.productId) {
          map[item.productId] = this.cloneValue(item, {})
        }
      })
      return map
    },
    getAllBudgetFromRow(row) {
      const data = row && row.AllBudget ? row.AllBudget : {}
      return {
        dayBudget: data.dayBudget !== undefined ? Number(data.dayBudget) : null,
        roiTarget: data.roiTarget !== undefined ? Number(data.roiTarget) : null,
        scheduleType: data.scheduleType === false ? 'CUSTOM' : 'LONG_TERM',
        timeRange: data.startTime && data.endTime ? [data.startTime, data.endTime] : []
      }
    },
    rowClick(row) {
      this.$refs.prodcutTable.toggleRowSelection(row)
    },
    toggleRowSelection(item, index) {
      const row = this.productTableData.find((obj) => String(obj.productId) === String(item.productId))
      if (row) {
        this.$refs.prodcutTable.toggleRowSelection(row)
      }
      if (item.cursor > this.productCursor) {
        this.selectedList.splice(index, 1)
      }
    },
    selectChange() {
      this.selectedList = []
    },
    isCheckedChange(checked) {
      if (!this.$refs.prodcutTable) {
        return
      }
      this.filteredProductTableData.forEach((item, index) => {
        if (index < 30) {
          this.$refs.prodcutTable.toggleRowSelection(item, checked)
        }
      })
    },
    selectionChange(data) {
      const list = []
      data.forEach((item) => {
        if (item) {
          list.push(item)
        }
      })
      this.selectedList.forEach((item) => {
        if (item.cursor > this.productCursor) {
          list.push(item)
        }
      })
      const uniqueMap = {}
      this.selectedList = list.filter((item) => {
        if (!item || !item.productId || uniqueMap[item.productId]) {
          return false
        }
        uniqueMap[item.productId] = true
        return true
      }).slice(0, 30)
    },
    saveProduct(type) {
      if (type) {
        const selectedProducts = this.normalizeProductList(this.selectedList)
        const rowPatch = this.buildProductSelectionRowPatch(selectedProducts)
        this.saveSelectObj = {
          list: selectedProducts,
          index: this.currentTableIndex,
          rowPatch: rowPatch
        }
        if (this.showPromotionConfigDrawer && this.currentPromotionIndex === this.currentTableIndex) {
          this.syncPromotionProducts(selectedProducts)
        }
      }
      this.showSelectProductPopup = false
      this.selectedList = []
      this.productSearchText = ''
    },
    selectProduct(obj) {
      this.isSelect30 = false
      const scope = obj.scope || {}
      const index = obj.index
      const type = obj.type
      const rowData = scope.row || {}
      if (type) {
        this.selectedList = []
      }
      this.currentTableIndex = index
      this.currentRowData = rowData
      this.productTableData = rowData.isEdit
        ? this.mergeProductList([], rowData.editList || rowData.selectedList || [])
        : []
      this.productCursor = 0
      this.hasMore = false
      this.loading = true
      const advertiserId = rowData.account ? rowData.account.id : null
      const aweMeId = rowData.selectedDYNumber ? rowData.selectedDYNumber.id : null
      const list = this.showPromotionConfigDrawer && this.currentPromotionIndex === index
        ? this.promotionConfigProducts
        : (rowData.selectedList || [])
      this.showSelectProductPopup = true
      this.getTableData(advertiserId, aweMeId, list)
    },
    openProductDrawerFromConfig() {
      if (this.currentPromotionIndex === null) {
        return
      }
      const row = this.currentRowData || {}
      this.selectProduct({
        scope: { row: row },
        index: this.currentPromotionIndex,
        type: 0
      })
    },
    loadMoreProducts() {
      const row = this.currentRowData || {}
      if (!this.hasMore || !row.account || !row.selectedDYNumber) {
        return
      }
      this.getTableData(row.account.id, row.selectedDYNumber.id, this.selectedList)
    },
    getTableData(advertiserId, aweMeId, list) {
      this.$axios.post({
        url: '/launchTheProduct/getListAvailableProducts',
        data: {
          advertiserId: advertiserId,
          aweMeId: aweMeId,
          cursor: this.productCursor || 0,
          notAll: true
        },
        success: (res) => {
          if (res.code === 0) {
            this.hasMore = !!res.hasMore
            if (res.cursor !== undefined && res.cursor !== null) {
              this.productCursor = res.cursor
            }
            if (Array.isArray(res.data)) {
              res.data.forEach((item) => {
                if (item.tag && typeof item.tag === 'string') {
                  item.tagArr = item.tag.slice(1, -1).split(/,\s*/)
                }
                item.cursor = this.productCursor || 0
              })
              this.productTableData = this.mergeProductList(this.productTableData, res.data)
            }
            this.loading = false
            if (list && list.length) {
              this.selectedList = this.normalizeProductList(list)
              this.$nextTick(() => {
                this.selectedList.forEach((item) => {
                  const row = this.productTableData.find((data) => String(data.productId) === String(item.productId))
                  if (row) {
                    this.$refs.prodcutTable.toggleRowSelection(row, true)
                  }
                })
              })
            }
          } else {
            this.loading = false
            this.$message.error(res.msg)
          }
        },
        error: () => {
          this.loading = false
          this.$message.error('商品加载失败')
        }
      })
    },
    openPromotionConfig(payload) {
      const scope = payload.scope || {}
      const index = payload.index
      const row = this.cloneValue(scope.row, {})
      this.currentPromotionIndex = index
      this.currentRowData = row
      this.promotionConfigProducts = this.normalizeProductList(row.selectedList || [])
      this.promotionConfigSelectedCreativeMap = this.normalizeSelectedCreativeMap(row.selectedCreatives || [])
      this.promotionConfigForm = Object.assign({
        deliveryMode: 'COST',
        materialMode: 'AUTO'
      }, this.getAllBudgetFromRow(row), {
        deliveryMode: row.deliveryMode || 'COST',
        materialMode: row.materialMode || 'AUTO'
      })
      this.currentConfigProductId = this.promotionConfigProducts.length ? this.promotionConfigProducts[0].productId : null
      this.showPromotionConfigDrawer = true
    },
    switchConfigProduct(productId) {
      this.currentConfigProductId = productId
    },
    syncPromotionProducts(products) {
      const normalizedProducts = this.normalizeProductList(products)
      const validIds = normalizedProducts.map((item) => String(item.productId))
      const nextCreativeMap = {}
      Object.keys(this.promotionConfigSelectedCreativeMap).forEach((key) => {
        if (validIds.indexOf(String(key)) !== -1) {
          nextCreativeMap[key] = this.promotionConfigSelectedCreativeMap[key]
        }
      })
      this.promotionConfigProducts = normalizedProducts
      this.promotionConfigSelectedCreativeMap = nextCreativeMap
      if (!this.currentConfigProductId || validIds.indexOf(String(this.currentConfigProductId)) === -1) {
        this.currentConfigProductId = normalizedProducts.length ? normalizedProducts[0].productId : null
      }
    },
    buildProductSelectionRowPatch(selectedProducts) {
      const rowPatch = {
        selectedList: selectedProducts
      }
      if (this.showPromotionConfigDrawer && this.currentPromotionIndex === this.currentTableIndex) {
        this.syncPromotionProducts(selectedProducts)
        rowPatch.selectedCreatives = this.buildSelectedCreativeList()
      }
      return rowPatch
    },
    getSelectedCreative(productId) {
      if (!productId) {
        return null
      }
      return this.promotionConfigSelectedCreativeMap[productId] || null
    },
    hasSelectedCreative(productId) {
      const creative = this.getSelectedCreative(productId)
      return !!(creative && creative.selectedVideoId)
    },
    getProductStatusText(productId) {
      if (this.promotionConfigForm.materialMode !== 'MANUAL') {
        return '自动素材'
      }
      const creative = this.getSelectedCreative(productId)
      if (!creative) {
        return '未配置素材'
      }
      if (!creative.selectedVideoId) {
        return '缺失视频'
      }
      if (!creative.selectedTitle) {
        return '缺失标题'
      }
      return '已配置'
    },
    getProductStatusClass(productId) {
      const text = this.getProductStatusText(productId)
      if (text === '已配置') {
        return 'status-success'
      }
      if (text === '自动素材') {
        return 'status-auto'
      }
      return 'status-warning'
    },
    getConfiguredProductCount() {
      if (this.promotionConfigForm.materialMode !== 'MANUAL') {
        return this.promotionConfigProducts.length
      }
      return this.promotionConfigProducts.filter((item) => {
        const creative = this.getSelectedCreative(item.productId)
        return creative && creative.selectedVideoId && creative.selectedTitle
      }).length
    },
    getPreviewCover() {
      const creative = this.getSelectedCreative(this.currentConfigProductId)
      if (creative && creative.selectedVideoCoverUrl) {
        return creative.selectedVideoCoverUrl
      }
      if (this.currentConfigProduct) {
        return this.currentConfigProduct.productImage || this.currentConfigProduct.img
      }
      return ''
    },
    getPreviewTitle() {
      const creative = this.getSelectedCreative(this.currentConfigProductId)
      if (creative && creative.selectedTitle) {
        return creative.selectedTitle
      }
      return '选择素材后将在这里预览标题'
    },
    getMaterialDuration(productId) {
      const list = this.materialOptionMap[productId] || []
      const creative = this.getSelectedCreative(productId)
      if (!creative || !creative.selectedVideoId) {
        return ''
      }
      const matched = list.find((item) => String(item.videoId) === String(creative.selectedVideoId))
      return matched && matched.duration ? matched.duration : ''
    },
    openMaterialDialog(product) {
      if (!product) {
        this.$message.warning('请先选择商品')
        return
      }
      this.materialDialogProductId = product.productId
      this.materialDialogProductName = product.productName
      this.materialDialogSelectedVideoId = this.getSelectedCreative(product.productId)
        ? this.getSelectedCreative(product.productId).selectedVideoId
        : null
      this.showMaterialDialog = true
      this.loadMaterialOptions(product, false)
    },
    reloadMaterialOptions() {
      if (!this.currentConfigProduct) {
        return
      }
      this.loadMaterialOptions(this.currentConfigProduct, true)
    },
    loadMaterialOptions(product, forceReload) {
      const row = this.currentRowData || {}
      if (!row.account || !row.account.id || !row.selectedDYNumber || !row.selectedDYNumber.id) {
        this.$message.error('当前账户缺少抖音号，无法加载素材')
        return
      }
      if (!forceReload && this.materialOptionMap[product.productId] && this.materialOptionMap[product.productId].length) {
        this.materialDialogList = this.materialOptionMap[product.productId]
        return
      }
      this.materialDialogLoading = true
      this.$axios.post({
        url: '/launchTheProduct/getProductCreativeList',
        data: {
          advertiserId: row.account.id,
          aweMeId: row.selectedDYNumber.id,
          productId: product.productId
        },
        success: (res) => {
          this.materialDialogLoading = false
          if (res.code === 0) {
            const list = res.data && Array.isArray(res.data.videoList) ? res.data.videoList : []
            this.$set(this.materialOptionMap, product.productId, list)
            this.materialDialogList = list
            if (!list.length) {
              this.$message.warning('当前商品暂无可用素材')
            }
          } else {
            this.materialDialogList = []
            this.$message.error(res.msg || '素材加载失败')
          }
        },
        error: () => {
          this.materialDialogLoading = false
          this.materialDialogList = []
          this.$message.error('素材加载失败')
        }
      })
    },
    confirmMaterialSelection() {
      if (!this.materialDialogSelectedVideoId) {
        this.$message.warning('请先选择一条视频素材')
        return
      }
      const selectedOption = this.materialDialogList.find((item) => String(item.videoId) === String(this.materialDialogSelectedVideoId))
      if (!selectedOption) {
        this.$message.error('未找到对应素材，请重新选择')
        return
      }
      const product = this.promotionConfigProducts.find((item) => String(item.productId) === String(this.materialDialogProductId))
      if (!product) {
        this.$message.error('商品信息已失效，请重新选择商品')
        return
      }
      this.$set(this.promotionConfigSelectedCreativeMap, product.productId, {
        productId: product.productId,
        productName: product.productName,
        productImage: product.productImage || product.img,
        selectedVideoId: selectedOption.videoId,
        selectedAwemeItemId: selectedOption.awemeItemId,
        selectedImageMode: selectedOption.imageMode,
        selectedTitle: selectedOption.title || product.productName,
        selectedMaterialId: selectedOption.materialId,
        selectedVideoCoverUrl: selectedOption.videoCoverUrl,
        selectedVideoUrl: selectedOption.videoUrl
      })
      this.showMaterialDialog = false
    },
    clearProductCreative(productId) {
      if (!productId) {
        return
      }
      this.$delete(this.promotionConfigSelectedCreativeMap, productId)
    },
    buildSelectedCreativeList() {
      const productIds = this.promotionConfigProducts.map((item) => String(item.productId))
      return Object.keys(this.promotionConfigSelectedCreativeMap)
        .filter((key) => productIds.indexOf(String(key)) !== -1)
        .map((key) => {
          const creative = this.cloneValue(this.promotionConfigSelectedCreativeMap[key], {})
          const product = this.promotionConfigProducts.find((item) => String(item.productId) === String(key))
          if (product) {
            creative.productName = creative.productName || product.productName
            creative.productImage = creative.productImage || product.productImage || product.img
          }
          return creative
        })
    },
    validatePromotionConfig() {
      if (!this.promotionConfigProducts.length) {
        this.$message.error('请先选择商品')
        return false
      }
      if (!this.promotionConfigForm.dayBudget) {
        this.$message.error('请设置日预算')
        return false
      }
      if (Number(this.promotionConfigForm.dayBudget) < 300 || Number(this.promotionConfigForm.dayBudget) > 999999999.99) {
        this.$message.error('日预算必须在300-999999999.99之间')
        return false
      }
      if (!this.promotionConfigForm.roiTarget) {
        this.$message.error('请设置净成交ROI目标')
        return false
      }
      if (Number(this.promotionConfigForm.roiTarget) < 0.01 || Number(this.promotionConfigForm.roiTarget) > 10000) {
        this.$message.error('净成交ROI目标必须在0.01-10000之间')
        return false
      }
      if (this.promotionConfigForm.scheduleType === 'CUSTOM') {
        if (!Array.isArray(this.promotionConfigForm.timeRange) || this.promotionConfigForm.timeRange.length !== 2) {
          this.$message.error('请设置开始和结束时间')
          return false
        }
      }
      if (this.promotionConfigForm.materialMode === 'MANUAL') {
        const invalidProduct = this.promotionConfigProducts.find((item) => {
          const creative = this.getSelectedCreative(item.productId)
          return !(creative && creative.selectedVideoId && creative.selectedAwemeItemId && creative.selectedTitle)
        })
        if (invalidProduct) {
          this.currentConfigProductId = invalidProduct.productId
          this.$message.error('自选素材模式下，每个商品都需要完成视频和标题配置')
          return false
        }
      }
      return true
    },
    savePromotionConfig() {
      if (!this.validatePromotionConfig()) {
        return
      }
      const allBudget = {
        dayBudget: this.promotionConfigForm.dayBudget,
        roiTarget: this.promotionConfigForm.roiTarget,
        scheduleType: this.promotionConfigForm.scheduleType === 'LONG_TERM',
        startTime: this.promotionConfigForm.scheduleType === 'CUSTOM' ? this.promotionConfigForm.timeRange[0] : null,
        endTime: this.promotionConfigForm.scheduleType === 'CUSTOM' ? this.promotionConfigForm.timeRange[1] : null
      }
      this.savePromotionConfigObj = {
        index: this.currentPromotionIndex,
        rowPatch: {
          selectedList: this.cloneValue(this.promotionConfigProducts, []),
          AllBudget: allBudget,
          deliveryMode: this.promotionConfigForm.deliveryMode || 'COST',
          materialMode: this.promotionConfigForm.materialMode || 'AUTO',
          selectedCreatives: this.buildSelectedCreativeList()
        }
      }
      this.showPromotionConfigDrawer = false
      this.$message.success('当前账户配置已保存')
    }
  }
}
</script>

<style scoped>
.drawer_title {
  padding: 15px 25px;
  width: 100%;
  font-weight: 600;
  font-size: 20px;
  background-color: #f7f9fc;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif;
}

/deep/ .row-pointer {
  cursor: pointer;
}

.product-drawer-body {
  position: relative;
  min-height: calc(100vh - 70px);
  box-sizing: border-box;
}

.search-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.search-input {
  width: 360px;
}

.selected-counter {
  color: #606266;
  font-size: 13px;
}

.add_product_box img {
  height: 110px;
  width: 110px;
  border-radius: 10px;
  object-fit: cover;
}

.footer_box {
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 90px;
  box-shadow: 0 -4px 6px #00000014;
  padding: 5px 30px;
  box-sizing: border-box;
  background: #fff;
}

.selectedListBox {
  height: 90px;
  width: 700px;
  overflow: auto;
}

.footer_box img {
  cursor: pointer;
  height: 70px;
  width: 70px;
  border-radius: 10px;
  object-fit: cover;
}

.footer_box i {
  position: absolute;
  top: -3px;
  right: -3px;
  transform: scale(1.2);
  cursor: pointer;
}

/deep/ .header_className {
  background-color: #e4eeff !important;
}

/deep/ .el-checkbox__inner {
  border-radius: 4px;
}

.promotion-config-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 68px);
  background: linear-gradient(180deg, #f4f8ff 0%, #fbfcff 42%, #ffffff 100%);
}

.promotion-config-main {
  flex: 1;
  overflow: auto;
  padding: 24px;
}

.step-card {
  background: #fff;
  border-radius: 20px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 14px 32px rgba(25, 74, 196, 0.08);
}

.step-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.step-index {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3f7cff 0%, #2864ea 100%);
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
  flex-shrink: 0;
}

.step-title {
  font-size: 20px;
  font-weight: 600;
  color: #1f2f56;
}

.step-subtitle {
  margin-top: 6px;
  color: #7081a6;
  font-size: 13px;
}

.account-summary,
.confirm-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.summary-item,
.confirm-item {
  background: #f7faff;
  border-radius: 14px;
  padding: 14px 16px;
}

.summary-label,
.confirm-label,
.budget-label,
.mini-label {
  color: #7b8cb1;
  font-size: 13px;
}

.summary-value,
.confirm-value {
  display: block;
  margin-top: 6px;
  color: #203153;
  font-size: 16px;
  font-weight: 600;
}

.goods-toolbar {
  margin-top: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.goods-tip,
.field-tip,
.editor-subtitle {
  color: #8b97b5;
  font-size: 12px;
}

.goods-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.goods-card,
.manual-product-tab,
.material-dialog-card,
.delivery-mode-card,
.material-mode-card {
  border: 1px solid #e0e8ff;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.goods-card:hover,
.manual-product-tab:hover,
.material-dialog-card:hover,
.material-mode-card:hover {
  border-color: #5c8eff;
  box-shadow: 0 10px 24px rgba(55, 102, 231, 0.12);
}

.goods-card.active,
.manual-product-tab.active,
.material-dialog-card.active,
.delivery-mode-card.active,
.material-mode-card.active {
  border-color: #3f7cff;
  box-shadow: 0 14px 30px rgba(54, 102, 231, 0.16);
}

.goods-card {
  display: flex;
  padding: 14px;
  gap: 14px;
}

.goods-card img,
.manual-product-tab img {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  object-fit: cover;
  flex-shrink: 0;
}

.goods-card-content,
.manual-product-meta {
  min-width: 0;
  flex: 1;
}

.goods-name,
.manual-product-name,
.dialog-card-title,
.preview-product-name {
  color: #1f2f56;
  font-weight: 600;
  line-height: 1.5;
}

.goods-id,
.dialog-card-meta,
.preview-product-id,
.mini-value {
  margin-top: 6px;
  color: #7482a7;
  font-size: 12px;
  word-break: break-all;
}

.goods-status,
.manual-product-status {
  margin-top: 10px;
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  background: #fff6df;
  color: #c28b15;
}

.status-success {
  background: #eaf8ef;
  color: #1f9d57;
}

.status-auto {
  background: #edf3ff;
  color: #2f66d4;
}

.status-warning {
  background: #fff6df;
  color: #c28b15;
}

.delivery-mode-grid,
.material-mode-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 14px;
}

.delivery-mode-card,
.material-mode-card {
  padding: 18px;
}

.delivery-mode-title,
.material-mode-title,
.editor-title {
  color: #213254;
  font-size: 16px;
  font-weight: 600;
}

.delivery-mode-desc,
.material-mode-desc {
  margin-top: 8px;
  color: #7180a5;
  font-size: 13px;
  line-height: 1.7;
}

.delivery-mode-card.disabled {
  opacity: 0.56;
  cursor: not-allowed;
  box-shadow: none;
}

.budget-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
}

.budget-item {
  background: #f8fbff;
  border-radius: 16px;
  padding: 18px;
}

.budget-input,
.time-range-picker {
  width: 100%;
  margin-top: 10px;
}

.schedule-block {
  margin-top: 20px;
}

.material-mode-grid {
  margin-bottom: 18px;
}

.auto-material-box {
  background: linear-gradient(135deg, #eef5ff 0%, #f7fbff 100%);
  border: 1px dashed #8bb4ff;
  border-radius: 16px;
  padding: 18px;
  color: #2e5fb9;
  display: flex;
  align-items: center;
  gap: 10px;
}

.manual-material-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 18px;
}

.manual-material-main,
.manual-material-preview {
  min-width: 0;
}

.manual-product-tabs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.manual-product-tab {
  min-width: 220px;
  padding: 12px;
  display: flex;
  gap: 12px;
  background: #fff;
}

.material-editor {
  margin-top: 18px;
  border: 1px solid #e7ecff;
  border-radius: 18px;
  padding: 18px;
  background: #fcfdff;
}

.material-editor-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.editor-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.danger-text {
  color: #f56c6c;
}

.selected-material-panel {
  margin-top: 18px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
}

.material-preview-card {
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  background: #f2f6ff;
  min-height: 280px;
}

.material-preview-card img,
.preview-cover,
.dialog-cover-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-duration,
.dialog-duration {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(18, 22, 34, 0.72);
  color: #fff;
  font-size: 12px;
}

.material-form {
  min-width: 0;
}

.material-field-row {
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.material-field {
  background: #f5f8ff;
  border-radius: 14px;
  padding: 14px;
}

.preview-phone {
  background: linear-gradient(180deg, #132743 0%, #203a62 18%, #f4f8ff 18%, #ffffff 100%);
  border-radius: 24px;
  padding: 16px;
  min-height: 500px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.2);
}

.preview-phone-header {
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-size: 13px;
  margin-bottom: 16px;
}

.preview-phone-body {
  background: #fff;
  border-radius: 18px;
  padding: 14px;
}

.preview-cover {
  height: 260px;
  border-radius: 16px;
}

.preview-product {
  margin-top: 14px;
  display: flex;
  gap: 12px;
  align-items: center;
}

.preview-product img {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  object-fit: cover;
}

.preview-title {
  margin-top: 16px;
  padding: 14px;
  background: #f5f8ff;
  border-radius: 16px;
  color: #223355;
  line-height: 1.7;
  min-height: 88px;
}

.promotion-config-footer {
  padding: 18px 24px;
  background: #fff;
  box-shadow: 0 -8px 20px rgba(31, 53, 100, 0.08);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.material-dialog-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.dialog-product-name {
  color: #1f2f56;
  font-weight: 600;
  margin-right: 12px;
}

.dialog-product-id {
  color: #7a89ad;
  font-size: 13px;
}

.material-dialog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.material-dialog-card {
  padding: 12px;
  background: #fff;
}

.dialog-cover-wrapper {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #f4f8ff;
  height: 260px;
}

.dialog-card-title {
  margin-top: 12px;
  min-height: 42px;
}

@media screen and (max-width: 1200px) {
  .manual-material-layout,
  .selected-material-panel {
    grid-template-columns: 1fr;
  }

  .goods-toolbar,
  .material-editor-header,
  .material-dialog-toolbar {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
